<app-background-image data-state="shipping"></app-background-image>
<app-topbar></app-topbar>
<app-sidebar [showNavigation]="true"></app-sidebar>

<div *ngIf="isLoading(mailLogs)">Loading...</div>
<div *ngIf="!isLoading(mailLogs)" class="main-content">
    <div class="table-container">
        <h3>Mail Logs</h3>
        <table class="table table-striped" *ngIf="!isEmpty(mailLogs)">
            <colgroup>
                <col style="width: auto" />
                <col style="width: auto" />
                <col style="width: auto" />
                <col style="width: auto" />
                <col style="width: auto" />
            </colgroup>
            <thead>
                <tr>
                    <th scope="col">Date</th>
                    <th scope="col">Mail Address</th>
                    <th scope="col">Mail type</th>
                    <th scope="col">Status</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let MailLog of mailLogs">
                    <td>{{ MailLog.created | date : "medium" }}</td>
                    <td>{{ MailLog.email }}</td>
                    <td>{{ MailLog.mailType }}</td>
                    <td>{{ MailLog.mailStatus }}</td>
                </tr>
            </tbody>
        </table>

        <h5 *ngIf="isEmpty(mailLogs)">No mails logged for this project.</h5>
    </div>
</div>
